import { render, staticRenderFns } from "./snapsuite-tenant-management.vue?vue&type=template&id=8eaf51b2"
import script from "./snapsuite-tenant-management.vue?vue&type=script&lang=ts"
export * from "./snapsuite-tenant-management.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports